export const primary = '#408996';
export const rgbPrimary = 'rgba(52, 185, 145)';